var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSolidIcon = function SvgStarSolidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.001 0c.492 0 .924.319 1.074.783L15.45 8.25h7.425a1.125 1.125 0 0 1 .69 2.01l-6.132 4.773 2.39 7.5c.15.469-.023.984-.426 1.265a1.13 1.13 0 0 1-1.336-.032l-6.06-4.716-6.062 4.71c-.389.306-.928.32-1.336.034a1.12 1.12 0 0 1-.426-1.266l2.39-7.495-6.13-4.772a1.125 1.125 0 0 1-.376-1.252c.155-.454.581-.759 1.064-.759h7.43L10.933.783A1.12 1.12 0 0 1 12 0"
  })));
};
export default SvgStarSolidIcon;